import React from 'react';
import { useAuth } from '../context/AuthContext';
import { FaShieldAlt, FaUserEdit, FaSignOutAlt, FaMapMarkerAlt, FaExternalLinkAlt, FaCheckCircle } from 'react-icons/fa';

export default function Navbar({ onOpenProfile }) {
  const { user, logout } = useAuth();

  if (!user) return null;

  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length > 1) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
  };

  return (
    <nav className="navbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
        <div className="brand">
          <div className="brand-icon">
            <FaShieldAlt />
          </div>
          <div className="brand-text">
            <h2>COP SUVIDHA</h2>
            <span>User Management</span>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              padding: '4px 10px',
              borderRadius: 'var(--radius-full)',
              background: '#eff6ff',
              color: 'var(--primary)',
              border: '1px solid #bfdbfe',
              fontSize: '0.75rem',
              fontWeight: 600,
            }}
          >
            <FaCheckCircle /> Verification Active
          </span>

          {/* <a
            href="https://copsuvidha.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              padding: '5px 12px',
              borderRadius: 'var(--radius-md)',
              background: '#f8fafc',
              color: '#334155',
              border: '1px solid var(--border-color)',
              fontSize: '0.8rem',
              fontWeight: 600,
              textDecoration: 'none',
              transition: 'all 0.15s ease',
            }}
            title="Open main copsuvidha.com website"
          >
            <span>Main Website</span>
            <FaExternalLinkAlt style={{ fontSize: '0.68rem', opacity: 0.7 }} />
          </a> */}
        </div>
      </div>

      <div className="nav-actions">
        {user.jurisdiction?.location_name && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              background: '#f1f5f9',
              borderRadius: 'var(--radius-full)',
              fontSize: '0.78rem',
              color: '#334155',
              border: '1px solid #e2e8f0',
              fontWeight: 500,
            }}
          >
            <FaMapMarkerAlt style={{ color: 'var(--primary)' }} />
            <span>{user.jurisdiction.location_name}</span>
          </div>
        )}

        <div className="user-profile-pill" onClick={onOpenProfile} title="Click to view profile & change name">
          <div className="user-avatar">{getInitials(user.name)}</div>
          <div className="user-info-text">
            <span className="user-name">{user.name || user.username}</span>
            <span className="user-role-sub">{user.role_label}</span>
          </div>
          <FaUserEdit style={{ color: 'var(--text-muted)', marginLeft: '4px' }} />
        </div>

        <button
          className="btn btn-secondary btn-sm"
          onClick={logout}
          title="Sign out from account"
          style={{ height: '36px', padding: '0 12px' }}
        >
          <FaSignOutAlt />
          <span>Logout</span>
        </button>
      </div>
    </nav>
  );
}
